<div class="detail">
  <mat-icon class="close" mat-dialog-close>close</mat-icon>
  <div class="title">评价</div>
  <div class="txt">
    <img
      src="../../../../../assets/images/workorder/ok.png"
      alt=""
    />评价成功，感谢您的评价
  </div>
</div>
